import React from 'react'
import styled from 'styled-components'
import { Box } from 'rebass'
import { rem, lighten } from 'polished'
import media from '../../../utils/style'

const TransitionButtonHolder = styled.div`
  position: absolute;
  float: right;
  width: auto !important;
  top: 0;
  right: 0;
  transform: translateX(0) !important;
  display: ${(props) => (props.vehicles > 1 ? 'block' : 'none')};
  ${media.MediumScreenUp`
  display: ${(props) => (props.vehicles > 2 ? 'block' : 'none')};
  `}
`

const TransitionButton = styled(({ theme, disable, ...rest }) => (
  <Box {...rest} />
))`
  cursor: ${(props) => (props.disable ? 'initial' : 'pointer')};
  position: relative;
  width: ${rem(35)} !important;
  height: ${rem(35)};
  background-color: ${(props) =>
    props.disable ? props.theme.colors.blue : props.theme.colors.blue};
  opacity: ${(props) => (props.disable ? 0.3 : 1)};
  margin-left: 1px;
  &:hover {
    background-color: ${(props) =>
      props.disable
        ? props.theme.colors.blue
        : lighten(0.12, props.theme.colors.blue)};
  }
  &:active svg {
    transform: ${(props) =>
      props.disable
        ? 'translate(-50%,-50%) scale(0.5)'
        : 'translate(-55%,-50%) scale(0.5)'};
  }
  svg {
    position: absolute;
    pointer-events: none;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0.5);
    height: 100%;
  }
`

const TransitionNext = styled(TransitionButton)`
  float: left;
  &:active svg {
    transform: ${(props) =>
      props.disable
        ? 'translate(-50%,-50%) scale(-0.5)'
        : 'translate(-45%,-50%) scale(-0.5)'};
  }
  svg {
    transform: translate(-50%, -50%) scale(-0.5);
    height: 100%;
  }
`
const TransitionPrev = styled(TransitionButton)`
  float: right;
`
export {
  TransitionPrev,
  TransitionNext,
  TransitionButton,
  TransitionButtonHolder
}
